import React, { useEffect, useState } from "react"
import { formatDateDataGrid } from "src/utils/format-date"
import PropTypes from 'prop-types'
import dayjs from "dayjs"
import { DATE_FORMAT, DATE_FORMAT_SHOW } from "src/utils/constants"
import DatalakeService from "src/services/datalake-service"
import ParameterPaginationTable from "src/components/table/parameter-pagination-table"

const ParameterPrecosValidacaoDiarioTable = (props) => {
    const datalakeService = new DatalakeService()
    const [data, setData] = useState([])
    const [pagination, setPagination] = useState({ count: 0, next: null, previous: null })

    useEffect(() => {
        loadData()
    }, [])

    const loadData = () => {
        props.loading(true)
        datalakeService.loadPaginationEndpoint(props.endpoint).then((response) => {
            props.loading(false)

            const { body } = response
            const { results, count, next, previous } = body
            const list = results.map((obj) => ({ ...obj, id: obj.ID }))

            setPagination({ count: count, next: next, previous: previous })
            setData(list)
        }).catch((err) => {
            props.loading(false)
            props.callbackError(err)
        }).finally(() => {
            props.loading(false)
        })
    }

    const createRow = async () => {
        const body = {
            "DataReferencia": dayjs().format(DATE_FORMAT),
            "CETIP": "N/A",
            "Cliente": "N/A",
            "Premium": "N/A",
            "FTrustee": "N/A",
            "Rating": "N/A",
            "ScoreRating": 0,
            "ValidadeRating": dayjs().format(DATE_FORMAT),
            "Indicador": "N/A",
            "CNPJ_Securitizador": "N/A",
            "Nome_Securitizador": "N/A",
            "CNPJ_AgenteFiduciario": "N/A",
            "Nome_AgenteFiduciario": "N/A",
            "Devedor": "N/A",
            "Fonte_Securitizador": "N/A",
            "Fonte_Fiduciario": "N/A",
            "PUPAR_C2P": 0,
            "PUPAR_Securitizador": 0,
            "PUPAR_Fiduciario": 0,
            "PU_Andado": "N/A",
            "DeltaPUPAR_C2P_Securitizador": 0,
            "DeltaPUPAR_C2P_Fiduciario": 0,
            "VarPUPAR_Securitizador": 0,
            "VarPUPAR_Fiduciario": 0,
            "Prioridade_Anterior": 0,
            "Prioridade_Atual": 0,
            "Prioridade_Securitizador": 0,
            "Prioridade_Fiduciario": 0,
            "Observacao": "N/A",
            "Data_Observacao": dayjs().format(DATE_FORMAT),
            "Responsavel": "N/A",
            "Tipo_Ajuste": "N/A",
            "Fonte_Ajuste": "N/A",
            "Status": "N/A",
            "Status_Anterior": "N/A",
            "Solicitacao_FINCS": "N/A",
            "Solicitacao_FTRUSTEE": "N/A",
            "Solicitacao_Fiduciario": "N/A",
            "Solicitacao_Securitizador": "N/A",
        }

        props.loading(true)
        return datalakeService.createTableEndpoint(props.endpoint, body).then(() => {
            props.loading(false)
            loadData(0, 25)
        }).catch((err) => {
            props.loading(false)

            console.error("Erro ao criar registro:")
            console.error("Mensagem:", err?.message)
            console.error("Response:", err?.response)
            console.error("Response data:", err?.response?.data)
            console.error("Status:", err?.response?.status)

            throw err
        })
    }

    const updateRow = async (newRow) => {
        const { 
            ID, DataReferencia, CETIP, Cliente, Premium, FTrustee, Rating, ScoreRating, ValidadeRating, Indicador,
            CNPJ_Securitizador, Nome_Securitizador, CNPJ_AgenteFiduciario, Nome_AgenteFiduciario, Devedor,
            Fonte_Securitizador, Fonte_Fiduciario, PUPAR_C2P, PUPAR_Securitizador, PUPAR_Fiduciario, PU_Andado,
            DeltaPUPAR_C2P_Securitizador, DeltaPUPAR_C2P_Fiduciario, VarPUPAR_Securitizador, VarPUPAR_Fiduciario,
            Prioridade_Anterior, Prioridade_Atual, Prioridade_Securitizador, Prioridade_Fiduciario, Observacao,
            Data_Observacao, Responsavel, Tipo_Ajuste, Fonte_Ajuste, Status, Status_Anterior, Solicitacao_FINCS,
            Solicitacao_FTRUSTEE, Solicitacao_Fiduciario, Solicitacao_Securitizador
        } = newRow

        const body = {
            "DataReferencia": DataReferencia,
            "CETIP": CETIP,
            "Cliente": Cliente,
            "Premium": Premium,
            "FTrustee": FTrustee,
            "Rating": Rating,
            "ScoreRating": ScoreRating,
            "ValidadeRating": ValidadeRating,
            "Indicador": Indicador,
            "CNPJ_Securitizador": CNPJ_Securitizador,
            "Nome_Securitizador": Nome_Securitizador,
            "CNPJ_AgenteFiduciario": CNPJ_AgenteFiduciario,
            "Nome_AgenteFiduciario": Nome_AgenteFiduciario,
            "Devedor": Devedor,
            "Fonte_Securitizador": Fonte_Securitizador,
            "Fonte_Fiduciario": Fonte_Fiduciario,
            "PUPAR_C2P": PUPAR_C2P,
            "PUPAR_Securitizador": PUPAR_Securitizador,
            "PUPAR_Fiduciario": PUPAR_Fiduciario,
            "PU_Andado": PU_Andado,
            "DeltaPUPAR_C2P_Securitizador": DeltaPUPAR_C2P_Securitizador,
            "DeltaPUPAR_C2P_Fiduciario": DeltaPUPAR_C2P_Fiduciario,
            "VarPUPAR_Securitizador": VarPUPAR_Securitizador,
            "VarPUPAR_Fiduciario": VarPUPAR_Fiduciario,
            "Prioridade_Anterior": Prioridade_Anterior,
            "Prioridade_Atual": Prioridade_Atual,
            "Prioridade_Securitizador": Prioridade_Securitizador,
            "Prioridade_Fiduciario": Prioridade_Fiduciario,
            "Observacao": Observacao,
            "Data_Observacao": Data_Observacao,
            "Responsavel": Responsavel,
            "Tipo_Ajuste": Tipo_Ajuste,
            "Fonte_Ajuste": Fonte_Ajuste,
            "Status": Status,
            "Status_Anterior": Status_Anterior,
            "Solicitacao_FINCS": Solicitacao_FINCS,
            "Solicitacao_FTRUSTEE": Solicitacao_FTRUSTEE,
            "Solicitacao_Fiduciario": Solicitacao_Fiduciario,
            "Solicitacao_Securitizador": Solicitacao_Securitizador,
        }

        props.loading(true)
        return datalakeService.updateTableEndpoint(props.endpoint, ID, body).then(() => {
            props.loading(false)
        }).catch((err) => {
            props.loading(false)
            throw err
        })
    }

    const onFilter = async (filterList, limit, offset) => {
        const query = filterList.map(obj => `${encodeURIComponent(obj.field)}=${encodeURIComponent(obj.value)}`).join('&')

        props.loading(true)
        datalakeService.loadPaginationEndpoint(props.endpoint, query, limit, offset).then((response) => {
            props.loading(false)
            const { body } = response
            const { results, count, next, previous } = body
            const list = results.map((obj) => ({ ...obj, id: obj.ID }))
            setPagination({ count: count, next: next, previous: previous })
            setData(list)
        })
    }

    const changePage = async (endpoint) => {
        props.loading(true)
        datalakeService.paginate(endpoint).then((response) => {
            props.loading(false)
            const { body } = response
            const { results, count, previous, next } = body
            const list = results.map((obj) => ({ ...obj, id: obj.ID }))

            setPagination({ count: count, next: next, previous: previous })
            setData(list)
        })
    }

    const columns = [
        { field: 'ID', headerName: '#', disableColumnMenu: true, disableFilter: true, flex: true, minWidth: 80 },
        {
            field: 'DataReferencia',
            headerName: 'DataReferencia',
            flex: 1,
            minWidth: 150,
            typeComponent: 'date',
            editable: true,
            renderCell: (params) => params.value ? dayjs(params.value).format(DATE_FORMAT_SHOW) : ''
        },
        { field: 'CETIP', headerName: 'CETIP', flex: 1, minWidth: 150, editable: true },
        { field: 'Cliente', headerName: 'Cliente', flex: 1, minWidth: 150, editable: true },
        { field: 'Premium', headerName: 'Premium', flex: 1, minWidth: 100, editable: true },
        { field: 'FTrustee', headerName: 'FTrustee', flex: 1, minWidth: 100, editable: true },
        { field: 'Rating', headerName: 'Rating', flex: 1, minWidth: 150, editable: true },
        { field: 'ScoreRating', headerName: 'ScoreRating', flex: 1, minWidth: 150, typeComponent: 'number', type: 'number', editable: true },
        {
            field: 'ValidadeRating',
            headerName: 'ValidadeRating',
            flex: 1,
            minWidth: 150,
            typeComponent: 'date',
            editable: true,
            renderCell: (params) => params.value ? dayjs(params.value).format(DATE_FORMAT_SHOW) : ''
        },
        { field: 'Indicador', headerName: 'Indicador', flex: 1, minWidth: 150, editable: true },
        { field: 'CNPJ_Securitizador', headerName: 'CNPJ_Securitizador', flex: 1, minWidth: 150, editable: true },
        { field: 'Nome_Securitizador', headerName: 'Nome_Securitizador', flex: 1, minWidth: 150, editable: true },
        { field: 'CNPJ_AgenteFiduciario', headerName: 'CNPJ_AgenteFiduciario', flex: 1, minWidth: 150, editable: true },
        { field: 'Nome_AgenteFiduciario', headerName: 'Nome_AgenteFiduciario', flex: 1, minWidth: 150, editable: true },
        { field: 'Devedor', headerName: 'Devedor', flex: 1, minWidth: 150, editable: true },
        { field: 'Fonte_Securitizador', headerName: 'Fonte_Securitizador', flex: 1, minWidth: 150, editable: true },
        { field: 'Fonte_Fiduciario', headerName: 'Fonte_Fiduciario', flex: 1, minWidth: 150, editable: true },
        { field: 'PUPAR_C2P', headerName: 'PUPAR_C2P', flex: 1, minWidth: 150, typeComponent: 'number', type: 'number', editable: true },
        { field: 'PUPAR_Securitizador', headerName: 'PUPAR_Securitizador', flex: 1, minWidth: 150, typeComponent: 'number', type: 'number', editable: true },
        { field: 'PUPAR_Fiduciario', headerName: 'PUPAR_Fiduciario', flex: 1, minWidth: 150, typeComponent: 'number', type: 'number', editable: true },
        { field: 'PU_Andado', headerName: 'PU_Andado', flex: 1, minWidth: 100, editable: true },
        { field: 'DeltaPUPAR_C2P_Securitizador', headerName: 'DeltaPUPAR_C2P_Securitizador', flex: 1, minWidth: 150, typeComponent: 'number', type: 'number', editable: true },
        { field: 'DeltaPUPAR_C2P_Fiduciario', headerName: 'DeltaPUPAR_C2P_Fiduciario', flex: 1, minWidth: 150, typeComponent: 'number', type: 'number', editable: true },
        { field: 'VarPUPAR_Securitizador', headerName: 'VarPUPAR_Securitizador', flex: 1, minWidth: 150, typeComponent: 'number', type: 'number', editable: true },
        { field: 'VarPUPAR_Fiduciario', headerName: 'VarPUPAR_Fiduciario', flex: 1, minWidth: 150, typeComponent: 'number', type: 'number', editable: true },
        { field: 'Prioridade_Anterior', headerName: 'Prioridade_Anterior', flex: 1, minWidth: 150, typeComponent: 'number', type: 'number', editable: true },
        { field: 'Prioridade_Atual', headerName: 'Prioridade_Atual', flex: 1, minWidth: 150, typeComponent: 'number', type: 'number', editable: true },
        { field: 'Prioridade_Securitizador', headerName: 'Prioridade_Securitizador', flex: 1, minWidth: 150, typeComponent: 'number', type: 'number', editable: true },
        { field: 'Prioridade_Fiduciario', headerName: 'Prioridade_Fiduciario', flex: 1, minWidth: 150, typeComponent: 'number', type: 'number', editable: true },
        { field: 'Observacao', headerName: 'Observacao', flex: 1, minWidth: 150, editable: true },
        {
            field: 'Data_Observacao',
            headerName: 'Data_Observacao',
            flex: 1,
            minWidth: 150,
            typeComponent: 'date',
            editable: true,
            renderCell: (params) => params.value ? dayjs(params.value).format(DATE_FORMAT_SHOW) : ''
        },
        { field: 'Responsavel', headerName: 'Responsavel', flex: 1, minWidth: 150, editable: true },
        { field: 'Tipo_Ajuste', headerName: 'Tipo_Ajuste', flex: 1, minWidth: 150, editable: true },
        { field: 'Fonte_Ajuste', headerName: 'Fonte_Ajuste', flex: 1, minWidth: 150, editable: true },
        { field: 'Status', headerName: 'Status', flex: 1, minWidth: 150, editable: true },
        { field: 'Status_Anterior', headerName: 'Status_Anterior', flex: 1, minWidth: 150, editable: true },
        { field: 'Solicitacao_FINCS', headerName: 'Solicitacao_FINCS', flex: 1, minWidth: 150, editable: true },
        { field: 'Solicitacao_FTRUSTEE', headerName: 'Solicitacao_FTRUSTEE', flex: 1, minWidth: 150, editable: true },
        { field: 'Solicitacao_Fiduciario', headerName: 'Solicitacao_Fiduciario', flex: 1, minWidth: 150, editable: true },
        { field: 'Solicitacao_Securitizador', headerName: 'Solicitacao_Securitizador', flex: 1, minWidth: 150, editable: true },
        {
            field: 'CriadoEm',
            headerName: 'Data de Criação',
            flex: true,
            minWidth: 150,
            disableColumnMenu: true,
            disableFilter: true,
            renderCell: (params) => formatDateDataGrid(params)
        },
        {
            field: 'AtualizadoEm',
            headerName: 'Data de Atualização',
            flex: true,
            minWidth: 150,
            disableColumnMenu: true,
            disableFilter: true,
            renderCell: (params) => formatDateDataGrid(params)
        }
    ]

    return (
        <div>
            <ParameterPaginationTable
                columns={columns}
                data={data}
                setData={setData}
                createRow={createRow}
                updateRow={updateRow}
                pagination={pagination}
                onChangePage={changePage}
                filterFunction={onFilter}
                customFilter={true} />
        </div>
    )
}

ParameterPrecosValidacaoDiarioTable.propTypes = {
    loading: PropTypes.func,
    endpoint: PropTypes.string,
    callbackError: PropTypes.func
}

export default ParameterPrecosValidacaoDiarioTable